module.exports = __webpack_public_path__ + "img/pasi.beeabc1a.png";